// extracted by mini-css-extract-plugin
module.exports = {"container":"CommonBasicModal_container__iAEAH","background":"CommonBasicModal_background__PK6an","whiteboard":"CommonBasicModal_whiteboard__StDeN"};